import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { AxiosResponse } from "axios";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { DeleteInventoryResponseSchema } from "../response/DeleteInventoryResponse";

interface DeleteInventoryData {
    id: string;
}

export const useDeleteInventory = () => {
    return useMutation({
        mutationKey: ['inventories', 'delete'],
        mutationFn: async (formData: DeleteInventoryData) => privateApi.delete(`/v4/inventory/${formData.id}`),
        onSuccess: async (response: AxiosResponse) => {
            const validationResult = DeleteInventoryResponseSchema.safeParse(response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid inventory data format");
            }

            return validationResult.data;
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid inventory data format");
            } else {
                console.error(`Failed to delete inventory`, error);
                throw error;
            }
        }
    })
}
